import { render, staticRenderFns } from "./dailyreport.vue?vue&type=template&id=06fb8ad8&"
import script from "./dailyreport.vue?vue&type=script&lang=js&"
export * from "./dailyreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports